const unicodeToChar = text => 
  text.replace(/\\u[\dA-F]{4}/gi,
    match => String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16)));

const handleBackslash = text => text.replace(/\\\//gi, '/');

const parseTitles = text => unicodeToChar(handleBackslash(text));

const blogTitles = document.querySelectorAll(".h3-patta-custom");

blogTitles.forEach((title, i) => {
  const singleTitle = title.dataset.blogTitle;
  const splitTitle = singleTitle
    .split(" ")
    .map(
      (c, i) =>
        `<div class="text-transition" style="transition-delay: ${
          i / 45
        }s">${parseTitles(c)}</div>`
    );
  

  const titleTemplate = `<div style="font-weight: 900; text-transform: uppercase;">${
    screen.width > 749 ? splitTitle.join(" ") : parseTitles(singleTitle)
  }</div>`;
  blogTitles[i].innerHTML = titleTemplate;
});
